<add-manage-wrapper
  *ngIf="{ assetList: assetIds | idsToItems:assets } as vars"
  [hideHRule]="true" 
  [titleIcon]="hideTitle ? null : titleIcon" 
  [wrapperTitle]="hideTitle ? '' : title" 
  [openLabel]="readOnly ? '' : addLabel" 
  (open)="addAsset($event)"
  >
    <div class="empty-text" *ngIf="!vars.assetList?.length">No assets.</div>
    <ng-container *ngFor="let asset of vars.assetList">
      <status-wrapper 
        *ngIf="type === 'widePod' && { 
          entity: allEntities[asset.id], 
          associated: allEntities[asset.associatedId], off: asset?.status === 'Off' || !asset?.status || !allEntities[asset.id],
          category:  assetCategories[asset.entityTypeId]
          } as vars" 
        class="wide"
        [ngClass]="{ clickable: !readOnly }"
        [wideFormat]="true"
        [status]="vars.off ? null : asset.status"
        [hideStatus]="vars.off"
        [readyStatus]="asset.ready ? 'Ready' : 'NotReady'"
        [threeDotOptions]="threeDotOptions"
        [statusOptions]="itemStatus"
        [readOnly]="readOnly"
        (click)="readOnly ? null : editAsset(asset)"
        (threeDotSelection)="dotMenuSelection(asset, $event)" 
        (changeStatus)="changeStatus(asset, $event)"
        (changeReadyStatus)="changeReadyStatus(asset, $event)"
        >
        <div class="wideContent">
          <asset-card [tryToShowAsLink]="true" [asset]="asset"></asset-card>
          <div class="entity" *ngIf="!!vars.associated">
            {{ vars.associated.name }}<br/>
            <span class="type">({{ vars.associated.type | titlecase }})</span>
          </div>
          <div class="entity" *ngIf="!!vars.category">
            {{ vars.category.name || 'Unnamed Asset Category' }}
          </div>
        </div>
        
      </status-wrapper>
      <asset-link class="wideContent" *ngIf="type === 'informable'" [readOnly]="readOnly" [asset]="asset" (openAsset)="editAsset(asset)"></asset-link>
    </ng-container>
</add-manage-wrapper>